import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onReload", "actions", "translations"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { createButtonComponent } from "../Button.js";
import { ReloadIcon } from "./icons.js";
export function createChatMessageErrorComponent(_ref) {
  var createElement = _ref.createElement;
  var Button = createButtonComponent({
    createElement: createElement
  });
  return function ChatMessageError(userProps) {
    var onReload = userProps.onReload,
      actions = userProps.actions,
      userTranslations = userProps.translations,
      props = _objectWithoutProperties(userProps, _excluded);
    var translations = _objectSpread({
      errorMessage: 'Sorry, we are not able to generate a response at the moment. Please retry or contact support.',
      retryText: 'Retry'
    }, userTranslations);
    return createElement("article", _extends({
      className: "ais-ChatMessageError ais-ChatMessage ais-ChatMessage--left ais-ChatMessage--subtle"
    }, props), createElement("div", {
      className: "ais-ChatMessage-container"
    }, createElement("div", {
      className: "ais-ChatMessage-content"
    }, createElement("div", {
      className: "ais-ChatMessage-message"
    }, translations.errorMessage), (actions || onReload) && createElement("div", {
      className: "ais-ChatMessage-actions"
    }, actions ? actions.map(function (action, index) {
      return createElement(Button, _extends({
        key: index,
        variant: "ghost",
        className: "ais-ChatMessage-action"
      }, action), action.children);
    }) : createElement(Button, {
      variant: "primary",
      size: "md",
      className: "ais-ChatMessage-errorAction",
      onClick: function onClick() {
        return onReload === null || onReload === void 0 ? void 0 : onReload();
      }
    }, createElement(ReloadIcon, {
      createElement: createElement
    }), translations.retryText)))));
  };
}